import { useQuery } from '@apollo/client';
import { CAN_CHANGE_GROUP_ROOM_TYPE } from 'graphql/service';

type UseCanChangeGroupRoomTypeProps = {
  groupId?: string;
  newRoomTypeId?: string | null;
  enabled?: boolean;
};

export const useCanChangeGroupRoomType = ({
  groupId,
  newRoomTypeId,
  enabled = true,
}: UseCanChangeGroupRoomTypeProps) => {
  const shouldSkip = !enabled || !groupId || !newRoomTypeId;

  const { data, loading, error } = useQuery(CAN_CHANGE_GROUP_ROOM_TYPE, {
    variables: {
      data: {
        groupId,
        newRoomTypeId,
      },
    },
    skip: shouldSkip,
    fetchPolicy: 'no-cache',
  });

  return {
    canChangeGroupRoomType: shouldSkip ? false : !!data?.canChangeGroupRoomType,
    loading,
    error,
  };
};